import React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import {
    MdCheckCircle, MdInfo, MdWarning, MdError
} from 'react-icons/md';
import 'react-toastify/dist/ReactToastify.css';
import './customToastStyles.css';

export const notifySuccess = (message) =>
    toast.success(message, {
        icon: <MdCheckCircle size={22} color="green" />,
    });

export const notifyInfo = (message) =>
    toast.info(message, {
        icon: <MdInfo size={22} color="#007bff" />,
    });

export const notifyWarning = (message) =>
    toast.warn(message, {
        icon: <MdWarning size={22} color="#f57c00" />,
    });

export const notifyError = (message) =>
    toast.error(message, {
        icon: <MdError size={22} color="#d32f2f" />,
    });

export const CustomToastContainer = () => (
    <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        toastClassName="custom-toast"
        bodyClassName="custom-toast-body"
        progressClassName="custom-toast-progress"
    />
);
